import { computed } from "vue";
import authStore from "@/store/auth.ts";

export const PERMISSION_DENIED_MESSAGE = "Você não tem permissão para executar essa ação";

export function usePermissions() {
  const userPermissions = computed(() => authStore.state.current_user.permissions);
  const userIsAdmin = computed(() => authStore.state.current_user.is_admin);

  const hasPermission = (permissions: string[] | string) => {
    if (userIsAdmin.value) return true;
    if (Array.isArray(permissions)) {
      return permissions.some((permission) => userPermissions.value.includes(permission));
    }
    return userPermissions.value.includes(permissions);
  };

  return { hasPermission };
}
